<template>
    <div>
      <div
      v-if="isMobbileView || isTabletView"
      class="usage-detail__date-navigation-mobile">
        <div class="usage-detail__date-navigation-mobile__controls-container">
          <div class="usage-detail__date-navigation-mobile__controls-container__row usage-detail__primary-controls">
            <div class="usage-detail__date-navigation-mobile__controls-container__row__col">
              <div v-if="showComparisonDetails" class="usage-detail__date-navigation__comparison-container-mobile">
                <div v-if="comparisonDetailsType" class="comparison-details">{{comparisonDetailsType}}</div>
                <div v-if="comparisonDetailsDate" class="comparison-details">{{comparisonDetailsDate}}</div>
              </div>
              <div
              class="usage-detail__date-navigation-mobile__selected-date-container"
              v-if="selectedDate">
                <div v-if="selectedDate" class="usage-detail__date-navigation-mobile__selected-date-container__selected-date">{{selectedDate}}</div>
                <div v-if="selectedDateSubText" v-html="selectedDateSubText" class="usage-detail__date-navigation-mobile__selected-date-container__selected-date-sub-text"></div>
              </div>
            </div>
            <div class="usage-detail__date-navigation-mobile__controls-container__row__col">
              <DateNavigationButtonBack
              v-if="showDateBackwardsButton"
              :goBack="onDateBackwardsClicked"
              class="usage-detail__date-navigation-item"
              :disabled="disableAllDateNavControls || disableDateNavigationButtonBack" />

              <DateNavigationButtonForward
              v-if="showDateForwardsButton"
              :goForward="onDateForwardsClicked"
              class="usage-detail__date-navigation-item"
              :disabled="disableAllDateNavControls || disableDateNavigationButtonForward" />
            </div>
          </div>
          <div class="usage-detail__date-navigation-mobile__controls-container__wrapper">
            <div class="usage-detail__date-navigation-mobile__controls-container__row">
              <div
              @click="toggleMobileViewOptionsVisible()"
              class="usage-detail__date-navigation-item-mobile__view-options">
                {{mobileViewOptionsVisible ? 'Hide Controls' : 'Show Controls'}}
                <i class="usage-detail__date-navigation-item-mobile__view-options__caret" :class="{'caret-up': mobileViewOptionsVisible, 'caret-down': !mobileViewOptionsVisible}"></i>
              </div>
            </div>
            <div
            v-if="mobileViewOptionsVisible"
            class="usage-detail__date-navigation-mobile__controls-container__row gds-flex-container--left">
              <DateNavigationButtonMobile
              v-if="showJumpToDateButton"
              buttonText="Go To Date"
              :buttonClicked="showDatePicker"
              class="usage-detail__date-navigation-item"
              :disabled="disableAllDateNavControls || disableDateNavigationButtonJumpToDate"/>

              <DateNavigationButtonMobile
              v-if="showComparisonDateButton"
              buttonText="Comparison Date"
              :buttonClicked="showDatePickerSecondary"
              class="usage-detail__date-navigation-item"
              :disabled="disableAllDateNavControls || disableDateNavigationButtonCalendar"/>

              <DateNavigationButtonMobile
              v-if="showSimpleDatePickerButton"
              buttonText="Go To Date"
              :buttonClicked="showDatePicker"
              class="usage-detail__date-navigation-item"
              :disabled="disableAllDateNavControls || disableDateNavigationButtonCalendar"/>

              <DateNavigationButtonMobile
              v-if="showGoToTodayButton"
              buttonText="Go To Today"
              :buttonClicked="onGoToTodayClicked"
              class="usage-detail__date-navigation-item"
              :disabled="disableAllDateNavControls || disableDateNavigationButtonGoToToday"/>

              <DateNavigationButtonMobile
              v-if="showViewOptionsButton"
              :buttonText="viewOptionsLabel"
              :buttonClicked="onViewOptionsClicked"
              class="usage-detail__date-navigation-item"
              :disabled="disableAllDateNavControls || disableDateNavigationButtonGoToToday"/>

              <UsageDetailSelectMobile
              v-if="selectConfigMonthlyDailyHourly"
              :addBackground="true"
              modalTitle="Compare Granularity"
              :config="selectConfigMonthlyDailyHourly"
              :disabled="disableAllDateNavControls"
              :optionSelected="onOptionSelectedMonthlyDailyHourly"/>

              <UsageDetailSelectMobile
              v-if="selectConfigUsageType"
              :addBackground="true"
              modalTitle="Data Series"
              :config="selectConfigUsageType"
              :disabled="disableAllDateNavControls"
              :optionSelected="onOptionSelectedUsageType"/>

              <UsageDetailSelectMobile
              v-if="selectConfigTableSort"
              :addBackground="true"
              modalTitle="Sort Order"
              :config="selectConfigTableSort"
              :disabled="disableAllDateNavControls"
              :optionSelected="onOptionSelectedTableSort"/>

              <UsageDetailSelectMobile
              v-if="selectConfigCalendarMonthsBillingPeriod"
              :addBackground="true"
              modalTitle="Time Grouping"
              :disabled="disableAllDateNavControls"
              :config="selectConfigCalendarMonthsBillingPeriod"
              :optionSelected="onOptionSelectedCalendarMonthsBillingPeriod"/>

              <UsageDetailCheckboxes
              v-if="selectConfigCheckboxes"
              :addBackground="true"
              :buttonText="selectConfigCheckboxes.buttonText || 'Options'"
              :modalTitle="selectConfigCheckboxes.modalTitle || 'Please Select'"
              :disabled="disableAllDateNavControls"
              :config="selectConfigCheckboxes"
              :checkboxChanged="onCheckboxesModalChange"/>

              <UsageDetailDatePickerMobile
              v-if="(showSimpleDatePickerButton || showJumpToDateButton ) && datePickerVisible"
              modalTitle="Go To Date"
              :closeModal="closeDatePickers"
              :datePickerDefaultDate="datePickerDefaultDate"
              :datePickerVisible="datePickerVisible"
              :datePickerDateType="datePickerDateType"
              :disabled="disableAllDateNavControls"
              :disabledDates="datePickerDisabledDates"
              :selectedDateChanged="onSelectedDateChanged"/>

              <UsageDetailDatePickerMobile
              v-if="(showSimpleDatePickerButton || showJumpToDateButton ) && datePickerVisibleSecondary"
              modalTitle="Comparison Date"
              :closeModal="closeDatePickers"
              :datePickerDefaultDate="datePickerDefaultDateSecondary"
              :datePickerVisible="datePickerVisibleSecondary"
              :datePickerDateType="datePickerDateType"
              :disabled="disableAllDateNavControls"
              :disabledDates="datePickerDisabledDatesSecondary"
              :selectedDateChanged="onSelectedDateChangedSecondary"/>

              <div v-if="showAccountSwitcher" class="usage-detail__account-switcher-container">Viewing usage for <widget-account-switcher :minified="true"></widget-account-switcher></div>
              </div>
          </div>
        </div>
      </div>
      <div v-if="isDesktopView" class="usage-detail__header-content">
        <div class="usage-detail-controls-container" v-click-outside="closeDatePickers">
          <div class="usage-detail__primary-controls">
              <div class="usage-detail__primary-title">
                <div v-if="selectedDate"
                class="usage-detail__selected-date-container">
                  <h2 v-if="selectedDate" class="usage-detail__selected-date-container__selected-date">{{selectedDate}}</h2>
                  <div v-if="selectedDateSubText" v-html="selectedDateSubText" class="usage-detail__selected-date-container__selected-date-sub-text"></div>
                </div>

                <div
                v-if="isCompareRoute && showComparisonDetails"
                class="usage-detail__date-navigation__comparison-container-desktop">
                    <div v-if="comparisonDetailsType" class="comparison-details">{{comparisonDetailsType}}</div>
                    <div v-if="comparisonDetailsDate" class="comparison-details">{{comparisonDetailsDate}}</div>
                </div>
                <div
                class="usage-detail__date-navigation-mobile__selected-date-container"
                v-if="isCompareRoute && selectedDate">
                  <div v-if="selectedDate" class="usage-detail__date-navigation-mobile__selected-date-container__selected-date">{{selectedDate}}</div>
                  <div v-if="selectedDateSubText" v-html="selectedDateSubText" class="usage-detail__date-navigation-mobile__selected-date-container__selected-date-sub-text"></div>
                </div>
              </div>
            
              
            
          </div>

          <div class="usage-detail__secondary-controls">  
            <div class="usage-detail-controls-container__left-side">
              <DateNavigationButtonBack
                v-if="showDateBackwardsButton"
                :goBack="onDateBackwardsClickedHandler"
                class="usage-detail__date-navigation-item"
                :disabled="disableAllDateNavControls || disableDateNavigationButtonBack" />

                <DateNavigationButtonForward
                v-if="showDateForwardsButton"
                :goForward="onDateForwardsClickedHandler"
                class="usage-detail__date-navigation-item"
                :disabled="disableAllDateNavControls || disableDateNavigationButtonForward" />
              <div>
                <UsageDetailDatePicker
                v-if="showSimpleDatePickerButton || showJumpToDateButton"
                :datePickerDefaultDate="datePickerDefaultDate"
                :datePickerVisible="datePickerVisible"
                :datePickerDateType="datePickerDateType"
                :disabled="disableAllDateNavControls"
                :disabledDates="datePickerDisabledDates"
                :selectedDateChanged="onSelectedDateChanged"/>
              </div>

              <DateNavigationButtonCalendar
              v-if="showSimpleDatePickerButton"
              :showCalendar="showDatePicker"
              class="usage-detail__date-navigation-item"
              :disabled="disableAllDateNavControls || disableDateNavigationButtonCalendar"/>

              <DateNavigationButtonJumpToDate
              v-if="showJumpToDateButton"
              :jumpToDate="showDatePicker"
              :buttonLabel="jumpToDateButtonLabel"
              class="usage-detail__date-navigation-item"
              :disabled="disableAllDateNavControls || disableDateNavigationButtonJumpToDate"/>

              <DateNavigationButtonJumpToDate
              v-if="showComparisonDateButton"
              :jumpToDate="showDatePickerSecondary"
              buttonLabel="Comparison Date"
              class="usage-detail__date-navigation-item"
              :disabled="disableAllDateNavControls || disableDateNavigationButtonJumpToDate"/>

              <DateNavigationButtonGoToToday
              v-if="showGoToTodayButton"
              :goToToday="onGoToTodayClickedHandler"
              class="usage-detail__date-navigation-item"
              :disabled="disableAllDateNavControls || disableDateNavigationButtonGoToToday"/>

              <div>
                <UsageDetailDatePicker
                v-if="showComparisonDateButton"
                :datePickerDefaultDate="datePickerDefaultDateSecondary"
                :datePickerVisible="datePickerVisibleSecondary"
                :datePickerDateType="datePickerDateType"
                :disabled="disableAllDateNavControls"
                :disabledDates="datePickerDisabledDatesSecondary"
                :selectedDateChanged="onSelectedDateChangedSecondary"/>
              </div>

              <span v-if="summaryText" class="usage-detail__performance-summary" v-html="summaryText"></span>
            </div>
            <div class="usage-detail-controls-container__right-side">
              <UsageDetailSelect
              v-if="selectConfigTableSort"
              :config="selectConfigTableSort"
              :optionSelected="onOptionSelectedTableSort"/>

              <UsageDetailSelect
              v-if="selectConfigConsumptionOrGeneration"
              :config="selectConfigConsumptionOrGeneration"
              :optionSelected="onOptionSelectedConsumptionOrGeneration"/>

              <UsageDetailSelect
              v-if="selectConfigCalendarMonthsBillingPeriod"
              :config="selectConfigCalendarMonthsBillingPeriod"
              :optionSelected="onOptionSelectedCalendarMonthsBillingPeriod"/>

              <UsageDetailSelect
              v-if="selectConfigMonthlyDailyHourly"
              :config="selectConfigMonthlyDailyHourly"
              :optionSelected="onOptionSelectedMonthlyDailyHourlyHandler"/>

              <UsageDetailSelect
              v-if="selectConfigUsageType"
              :config="selectConfigUsageType"
              :optionSelected="onOptionSelectedUsageType"/>

              <UsageDetailCheckboxes
              v-if="selectConfigCheckboxes"
              :addBackground="true"
              :buttonText="selectConfigCheckboxes.buttonText || 'Options'"
              :modalTitle="selectConfigCheckboxes.modalTitle || 'Please Select'"
              :disabled="disableAllDateNavControls"
              :config="selectConfigCheckboxes"
              :checkboxChanged="onCheckboxesModalChange"/>

              <ButtonViewOptions
              v-if="showViewOptionsButton"
              :viewOptionsLabel="viewOptionsLabel ? viewOptionsLabel : 'View Options'"
              :viewOptions="onViewOptionsClicked"/>

              

            </div>
            
          </div>
          
   
        </div>
        <div v-if="showAccountSwitcher" class="usage-detail__account-switcher-container">Viewing usage for <widget-account-switcher :minified="true"></widget-account-switcher></div>
      </div>
    </div>
</template>

<script>
import MediaQueryMixin from "../../../mixins/MediaQueryMixin";
import UsageDetailSelect from "../usagedetailselect/UsageDetailSelect";
import ButtonViewOptions from "../../../../components/generic/ButtonViewOptions";
import UsageDetailSelectMobile from "../usagedetailselect/UsageDetailSelectMobile";
import UsageDetailDatePicker from "../usagedetaildatepicker/UsageDetailDatePicker";
import UsageDetailCheckboxes from "../usagedetailcheckboxes/UsageDetailCheckboxes";
import DateNavigationButtonBack from "../../../../components/generic/DateNavigationButtonBack";
import UsageDetailDatePickerMobile from "../usagedetaildatepicker/UsageDetailDatePickerMobile";
import DateNavigationButtonMobile from "../../../../components/generic/DateNavigationButtonMobile";
import DateNavigationButtonForward from "../../../../components/generic/DateNavigationButtonForward";
import DateNavigationButtonCalendar from "../../../../components/generic/DateNavigationButtonCalendar";
import DateNavigationButtonGoToToday from "../../../../components/generic/DateNavigationButtonGoToToday";
import DateNavigationButtonJumpToDate from "../../../../components/generic/DateNavigationButtonJumpToDate";
import WidgetAccountSwitcher from "../../../WidgetAccountSwitcher.vue";



export default {
  name: "UsageDetailControls",
  data() {
    return {
      escapeKey: 'Escape',
      isCompareRoute: false,
      mobileViewOptionsVisible: false,
      datePickerVisible: false,
      datePickerVisibleSecondary: false,
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydownEvent);
    this.isCompareRoute = this.$route.path && this.$route.path.startsWith('/compare');
  },
  mixins: [
    MediaQueryMixin
  ],
  watch: {
    comparisonDetailsWidth(val) {
      this.comparisonDetailsContainerWidth = val;
    }
  },
  computed: {
    currentAccount() {
      return this.$store.state.user.currentAccount;
    },
    isDesktopView() {
      return this.deviceIsExtraLarge
      || this.deviceIsExtraExtraLarge
      || this.deviceExceedsExtraExtraLarge;
    },
    isTabletView() {
      return this.deviceIsMedium
      || this.deviceIsLarge;
    },
    isMobbileView() {
      return this.deviceIsSmall;
    },
    showAccountSwitcher() {
      return this.numLinkedAccounts > 1;
    },
    numLinkedAccounts() {
      if (this.$store.state.user.accounts) {
        return this.$store.state.user.accounts.length;
      } else {
        return 0;
      }
    },
  },
  methods: {
    onGoToTodayClickedHandler() {
      this.onGoToTodayClicked();
      this.closeDatePickers();
    },
    onDateBackwardsClickedHandler() {
      this.onDateBackwardsClicked();
      this.closeDatePickers();
    },
    onDateForwardsClickedHandler() {
      this.onDateForwardsClicked();
      this.closeDatePickers();
    },
    onOptionSelectedMonthlyDailyHourlyHandler(event) {
      this.onOptionSelectedMonthlyDailyHourly(event);
      this.closeDatePickers();
    },
    toggleMobileViewOptionsVisible() {
      this.mobileViewOptionsVisible = !this.mobileViewOptionsVisible;
    },
    showDatePicker() {
      if (this.datePickerVisible) {
       this.closePrimaryPicker();
      } else {
      this.datePickerVisible = false;
      this.$nextTick(() => this.datePickerVisible = true);
      }
    },
    showDatePickerSecondary() {
      if (this.datePickerVisibleSecondary) {
        this.closeSecondaryPicker();
      } else {
      this.datePickerVisibleSecondary = false;
      this.$nextTick(() => this.datePickerVisibleSecondary = true);
      }
    },
    handleKeydownEvent(event) {
      if (event.key === this.escapeKey) {
          this.datePickerVisible = false;
          this.datePickerVisibleSecondary = false;
      }
    },
    closePrimaryPicker(){
      this.datePickerVisible = false;
    },
    closeSecondaryPicker(){
      this.datePickerVisibleSecondary = false;
    },
    closeDatePickers() {
      this.closePrimaryPicker();
      this.closeSecondaryPicker();
    }
    
  },
  components: {
    UsageDetailSelect,
    UsageDetailSelectMobile,
    UsageDetailCheckboxes,
    ButtonViewOptions,
    UsageDetailDatePicker,
    DateNavigationButtonBack,
    DateNavigationButtonForward,
    DateNavigationButtonCalendar,
    DateNavigationButtonGoToToday,
    DateNavigationButtonJumpToDate,
    UsageDetailDatePickerMobile,
    DateNavigationButtonMobile,
    WidgetAccountSwitcher,
  },
  props: {
    summaryText: String,
    selectedDate: String,
    selectedDateSubText: String,
    jumpToDateButtonLabel: String,
    showComparisonDetails: Boolean,
    comparisonDetailsType: String,
    comparisonDetailsDate: String,
    onGoToTodayClicked: Function,
    onJumpToDateClicked: Function,
    onViewOptionsClicked: Function,
    onDateBackwardsClicked: Function,
    onDateForwardsClicked: Function,
    showViewOptionsButton: Boolean,
    viewOptionsLabel: {
      type: String,
      default: 'View options'
    },
    showGoToTodayButton: Boolean,
    showJumpToDateButton: Boolean,
    showComparisonDateButton: Boolean,
    showSimpleDatePickerButton: Boolean,
    showDateBackwardsButton: Boolean,
    showDateForwardsButton: Boolean,
    datePickerDateType: String,
    datePickerDefaultDate: Date,
    datePickerDefaultDateSecondary: Date,
    datePickerDisabledDates: Object,
    datePickerDisabledDatesSecondary: Object,
    onSelectedDateChanged: Function,
    onSelectedDateChangedSecondary: Function,
    selectConfigCheckboxes: Object,
    selectConfigUsageType: Object,
    selectConfigTableSort: Object,
    selectConfigMonthlyDailyHourly: Object,
    selectConfigConsumptionOrGeneration: Object,
    selectConfigCalendarMonthsBillingPeriod: Object,
    onCheckboxesModalChange: Function,
    onOptionSelectedTableSort: Function,
    onOptionSelectedUsageType: Function,
    onOptionSelectedMonthlyDailyHourly: Function,
    onOptionSelectedCalendarMonthsBillingPeriod: Function,
    onOptionSelectedConsumptionOrGeneration: Function,
    disableAllDateNavControls: Boolean,
    disableDateNavigationButtonForward: Boolean,
    disableDateNavigationButtonBack: Boolean,
    disableDateNavigationButtonGoToToday: Boolean,
    disableDateNavigationButtonJumpToDate: Boolean,
    disableDateNavigationButtonCalendar: Boolean
  }
};
</script>

<style scoped>
</style>